import { Component } from '@angular/core';
import { SLACK_OAUTH_RESULT_MESSAGE_TYPE } from 'src/services/slack.service';

@Component({
  selector: 'app-close-window',
  templateUrl: './close-window.component.html',
  styleUrls: ['./close-window.component.css'],
})
export class CloseWindowComponent {
  message: string;

  constructor() {
    const error = new URLSearchParams(window.location.search).get('oauth_error');

    this.message = error
      ? `Slack authorization failed: ${error}`
      : 'Slack authorization complete. You can close this window.';

    if (window.opener) {
      window.opener.postMessage({ type: SLACK_OAUTH_RESULT_MESSAGE_TYPE, error }, window.location.origin);
      window.close();
    }
  }
}
